export const powerOnTime = 5;
